/**
 *
 * HomePagePro
 *
 */

import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { withSizes } from 'react-sizes';
import { makeStyles } from '@material-ui/core/styles';
import Mixpanel from 'utils/mixpanelService';
import Hero from './components/Hero';
import GoalsLine from './components/GoalsLine';
import SectionA from './components/SectionA';
import SectionB from './components/SectionB';
import StatsSection from './components/StatsSection';
import SolutionsSection from './components/SolutionsSection';
import SectionC from './components/SectionC';
import QuoteSection from './components/QuoteSection';
import ContactSection from './components/ContactSection';
import Footer from './components/Footer';
import './styles.css';

const useStyles = makeStyles({
  container: {
    paddingTop: ({ isMobile }) => (isMobile ? 0 : 54),
    overflowX: 'hidden',
  },
});

const HomePageWP = ({ isMobile }) => {
  const classes = useStyles({ isMobile });

  useEffect(() => {
    if (window.location.hash) {
      setTimeout(() => {
        const $anchor = document.getElementById(window.location.hash.slice(1));
        if ($anchor) {
          const offsetTop =
            $anchor.getBoundingClientRect().top + window.pageYOffset;
          window.scroll({
            top: offsetTop - 54,
            behavior: 'smooth',
          });
        }
      }, 1000);
    } else {
      window.scroll({
        top: 0,
      });
    }
    Mixpanel.track('Solutions Home Page - Viewed');
  }, []);

  // const handleScroll = (id, source) => {
  //   const $anchor = document.getElementById(id);
  //   if ($anchor) {
  //     const offsetTop =
  //       $anchor.getBoundingClientRect().top + window.pageYOffset;
  //     window.scroll({
  //       top: offsetTop - 54,
  //       behavior: 'smooth',
  //     });

  //     Mixpanel.track('Solutions Home Page - Navigation Clicked', {
  //       section: id,
  //       source,
  //     });
  //   }
  // };

  const handlePageExit = (url, source) => {
    Mixpanel.track('Solutions Home Page - Exit Page', {
      exitPage: url,
      source,
    });
  };

  return (
    <>
      {/* <SectionNavigator onClick={handleScroll} /> */}
      <div className={classes.container}>
        <Hero onPageExit={handlePageExit} />
        <GoalsLine />
        <SectionA onPageExit={handlePageExit} />
        <SectionB onPageExit={handlePageExit} />
        <StatsSection />
        <SolutionsSection />
        <SectionC onPageExit={handlePageExit} />
        <QuoteSection onPageExit={handlePageExit} />
        <ContactSection />
        <Footer />
      </div>
    </>
  );
};

HomePageWP.propTypes = {
  isMobile: PropTypes.bool,
};

const mapSizesToProps = ({ width }) => ({
  isMobile: width < 970,
});

export default withSizes(mapSizesToProps)(HomePageWP);
